/**
 * Shared promo validation constants.
 *
 * A promo (draft or live) can carry an empty room×rateplan selection — drafts
 * intentionally skip the combo check on save. The UI must not let such a promo
 * be created (launched), updated, or enabled: this message is shown as a toast
 * warning at each of those guard points. Used by useSubmitStandardPromo,
 * useSubmitDerivedPromo, and the Promotions page enable flow.
 */
export const EMPTY_COMBO_WARNING_MESSAGE =
  "No room type and rate plan combination is selected. Please select at least one before proceeding.";
